import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../../experiments/ExperimentParameterGroup';
import { acq142VariantBPostVerificationSteps } from '../../experiments/gswhV1/gswhUtils';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { isPreVerification } from '../../flow-settings/settingsSelectors';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { getIsMobile } from '../../utils/deviceUtils';
import { Step } from 'signup-constants/Step';
import { getStepConfig } from '../../views/getStepConfig';
export const BranchACQ142VariantB = {
  name: 'BranchACQ142VariantB',
  stateCheck: state => {
    return getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0142, [ExperimentParameterGroup.Variant_B]);
  },
  rebuildFlow: (flow, state, dispatch) => {
    const stepConfig = getStepConfig(Step.LandingPage);
    if (stepConfig) {
      stepConfig.hideProgressBar = false;
    }
    const preVerification = [Step.ProductExperience, Step.ProblemAwareness, Step.UseCase, Step.AhaMoment, Step.LandingPage, Step.CodeVerification];
    const postAccountCreationSteps = getIsMobile() ? [Step.MobileAppPrompt] : [];
    const nextSteps = [...(isPreVerification() ? preVerification : []), ...acq142VariantBPostVerificationSteps, ...postAccountCreationSteps];
    dispatch(setFlow(nextSteps, preVerification, acq142VariantBPostVerificationSteps, postAccountCreationSteps, getFlowSteps().postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: Step.LandingPage,
  afterData: null,
  afterStep: null
};